import { connect } from 'react-redux';
import { lifecycle, compose } from 'recompose';
import { prop } from 'ramda';

import { getCurrentStepName, getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import StepRenderer from './StepRenderer';

const withHardScrollTop = lifecycle({
  componentDidUpdate(prevProps) {
    if (prevProps.stepName !== this.props.stepName) {
      window.scrollTo(0, 0);
    }
  },
});

const mapStateToProps = state => ({
  stepName: getCurrentStepName(state),
  posName: prop('name', getPOSData(state)),
});

export default compose(
  connect(mapStateToProps),
  withHardScrollTop,
)(StepRenderer);
